module.exports = __webpack_public_path__ + "static/media/shop_anchorage_3.e235f939.svg";